define([
    "dojo/_base/declare",
    "mw-form/Menu",
    "mw-form/mixins/ResizeMixin",
    "../mixins/property/TypeMixin",
    "../mixins/property/PreventRestoreFocusMixin",
    "../mixins/ScrollbarMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, Menu, ResizeMixin, TypeMixin, PreventRestoreFocusMixin, ScrollbarMixin, mixinDependencyValidator) {

    function matchesSelector (/*Element*/ element, /*String*/ selector) { // TODO: use domUtils.matchesSelector instead
        var matchesMethod;

        if (!element || !selector) {
            return false;
        }

        matchesMethod = 
            Element.prototype.matches || 
            Element.prototype.matchesSelector || 
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector || 
            Element.prototype.oMatchesSelector || 
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;            
            };
 
        return matchesMethod.call(element, selector);
    };

    return declare(mixinDependencyValidator.validate([Menu, ResizeMixin, TypeMixin, PreventRestoreFocusMixin, ScrollbarMixin]), {
        visualFamily: "toolstrip",
        baseClass: "toolstrip mwSectionPopup",
        preventRestoreFocus: true,
        type: "SectionPopup",

        postCreate: function () {
            this.inherited(arguments);

            this.own(this.on("keydown", function (e) {
                switch (e.keyCode) {
                    case 27: // [Esc]
                        var popup = e.target;
                        while (!popup.classList.contains("dijitPopup") &&
                               (popup !== null) &&
                                popup.parentElement) {
                            popup = popup.parentElement;
                        }

                        if (popup) {
                            var sectionDropDown = document.getElementById(popup.getAttribute("dijitpopupparent"));
                            if (sectionDropDown && sectionDropDown.querySelector(".mwFocusNode")) {
                                sectionDropDown.querySelector(".mwFocusNode").focus();
                            } else {
                                this.emit("restorefocus");
                            }
                        } else {
                            this.emit("restorefocus");
                        }
                        return;
                    default:
                }
            }.bind(this)));
        },
        
        _emitRestoreFocus: function () {
            this.emit("restorefocus");
        },

        focus: function () {
            if (!this.isMenuOpen()) {
                return;
            }

            if (this._isCompactDisplayMode()) { // Display Mode Compact should not focus first child
                // Do not focus the popup in the Compact toolstrip mode - See g2144385 for details
            } else {
                var currentChild,
                    currentChildren,
                    currentNode,
                    focusableNode,
                    idx1 = 0,
                    idx2 = 0,
                    focusAttempted = false,
                    sectionChildren = this.getChildren();

                if (sectionChildren.length > 0) {
                    while (!focusAttempted && (idx1 < sectionChildren.length)) {
                        if (sectionChildren[idx1++].type === "Column") {
                            currentChildren = sectionChildren[idx1 - 1].getChildren();
                        } else {
                            currentChildren = sectionChildren;
                        }

                        if (currentChildren.length > 0) {
                            while (!focusAttempted && (idx2 < currentChildren.length)) {
                                currentChild = currentChildren[idx2++];

                                // Check if disabled
                                if ((currentChild.domNode && currentChild.get('disabled')) || ((currentChild instanceof Element) && currentChild.hasAttribute("disabled"))) {
                                    continue;
                                }

                                // If focus() method, then call, otherwise attempt to find focusNode
                                if (currentChild.focus) {
                                    currentChild.focus();
                                    focusAttempted = true;
                                } else {
                                    if (currentChild.domNode) {
                                        currentNode = currentChild.domNode;
                                    } else if (currentChild instanceof Element) {
                                        currentNode = currentChild;
                                    } else {
                                        // Unknown child type
                                        currentNode = null;
                                    }
                                    if (currentNode) {
                                        focusableNode =
                                            (currentNode.classList.contains(".mwFocusNode") ||
                                                (currentNode.hasAttribute("data-dojo-attach-point") &&
                                                    (currentNode.getAttribute("data-dojo-attach-point") === "focusNode"))) ?
                                            currentNode :
                                            currentNode.querySelector('.mwFocusNode') ||
                                                currentNode.querySelector('[data-dojo-attach-point="focusNode"]');

                                        if (focusableNode) {
                                            focusableNode.focus();
                                            focusAttempted = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            
            this._addFocusListeners();
        },
        
        _isCompactDisplayMode: function () {
            // TODO: make this more robust.  We should likely have a local property.
            return this.domNode ? matchesSelector(this.domNode, '.compactToolstripSectionPopup, .compactToolstripSectionPopup *') : null;
        }
    });
});
